import { useCallback } from 'react';
import { LexicalEditor, $getRoot, $createParagraphNode, $createTextNode, $createLineBreakNode } from 'lexical';

/**
 * Lexical EditorState ↔ Plain String 변환 훅
 * Phase 1: Plain text만 처리
 * Phase 2+: 마크다운 변환 추가 예정
 */
export const useLexicalContent = (editor: LexicalEditor | null) => {
  // EditorState에서 plain text 추출
  const getContent = useCallback((): string => {
    if (!editor) return '';

    return editor.getEditorState().read(() => {
      const root = $getRoot();
      return root.getTextContent();
    });
  }, [editor]);

  // Plain text를 EditorState로 설정
  const setContent = useCallback((text: string) => {
    if (!editor) return;

    editor.update(() => {
      const root = $getRoot();
      root.clear();

      // 빈 줄(\n\n)을 기준으로 paragraph 분리
      const paragraphs = text.split('\n\n');

      paragraphs.forEach((paragraphText, index) => {
        const paragraph = $createParagraphNode();

        // paragraph 내부의 단일 줄바꿈(\n)은 LineBreakNode로 처리
        const lines = paragraphText.split('\n');
        lines.forEach((line, lineIndex) => {
          if (lineIndex > 0) {
            paragraph.append($createLineBreakNode());
          }
          const textNode = $createTextNode(line);
          paragraph.append(textNode);
        });

        root.append(paragraph);
      });
    });
  }, [editor]);

  return { getContent, setContent };
};
